import { AppBundle } from 'api/optimalprint-sdk.d';
import React, { FC } from 'react';
import CategoryMenuItem from './CategoryMenuItem';
import styles from './CategoryMenu.module.scss';

interface CategoryMenuProps {
  items: AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response.ISidebarItem[];
  levelNum: number;
}

const CategoryMenu: FC<CategoryMenuProps> = ({ items, levelNum }) => {
  if (!items.length) {
    return null;
  }

  return (
    <ul className={styles.collections}>
      {items.map((item, index) => {
        return item.text ? (
          <CategoryMenuItem
            key={`${index}-${levelNum}-${item.categoryId}`}
            categoryId={item.categoryId}
            childItems={item.childItems || []}
            levelNum={levelNum}
            text={item.text}
            url={item.url}
          >
            {!!item.childItems && <CategoryMenu items={item.childItems} levelNum={levelNum + 1} />}
          </CategoryMenuItem>
        ) : null;
      })}
    </ul>
  );
};

export default CategoryMenu;
